var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zoom-block"},[_c('a',{on:{"click":_vm.zoomIn}},[_c('zoom-out-svg')],1),_vm._v(" "),_c('a',{on:{"click":_vm.zoomOut}},[_c('zoom-in-svg')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }